import type { ReactNode, ReactElement } from 'react';

// @mui
import {
  Avatar,
  Box,
  ListItem,
  ListItemAvatar,
  ListItemText,
} from '@mui/material';
// components
import Scrollbar from 'src/components/Scrollbar';
import ChatRoomCollapseButton from './ChatRoomCollapseButton';
import { useTranslation } from 'react-i18next';

export interface ParticipantProps {
  participant?: Record<string, any>;
  [key: string]: any;
}

// ----------------------------------------------------------------------

const HEIGHT = 60;

export default function ChatRoomGroup({
  participants,
  isCollapse,
  onCollapse,
  showCount = true,
}) {
  const { t } = useTranslation('translation');
  return (
    <>
      <ChatRoomCollapseButton isCollapse={isCollapse} onCollapse={onCollapse}>
        {showCount
          ? t('chat.participants', { count: participants.length })
          : t('chat.participants-label', { defaultValue: 'Participants' })}
      </ChatRoomCollapseButton>

      <Box
        sx={{
          height: isCollapse ? HEIGHT * 4 : 0,
          transition: (theme) =>
            theme.transitions.create('height', {
              duration: theme.transitions.duration.shorter,
            }),
        }}
      >
        <Scrollbar>
          {participants.map((participant) => (
            <Participant key={participant.identity} participant={participant} />
          ))}
        </Scrollbar>
      </Box>
    </>
  );
}

// ----------------------------------------------------------------------

function Participant({ participant }: ParticipantProps) {
  return (
    <ListItem sx={{ height: HEIGHT, px: 2.5 }}>
      <ListItemAvatar>
        <Avatar alt={participant.name} />
      </ListItemAvatar>

      <ListItemText
        primary={participant.name}
        primaryTypographyProps={{ noWrap: true, variant: 'subtitle2' }}
      />
    </ListItem>
  );
}
